import React, { useContext, useEffect, useState } from 'react'
import HomeVideo from '../../components/Home/HomeVideo'
import HomeServices from '../../components/Home/HomeServices'
import FeaturedVehicles from '../../components/Home/FeaturedVehicles'
import Testimonials from '../../components/Home/Testimonials'
import ContactInfo from '../../components/Home/ContactInfo'
import { VehicleContext } from '../../components/Context/VehicleContext'

const Home = () => {

  const {getVehicleData,featuredVehicles,numberFormatter} = useContext(VehicleContext);

  useEffect(() => {
      console.log("home page useEffect");

      getVehicleData();

  }, []);

  return (
    <>
      <HomeVideo/>
      <HomeServices/>
      {featuredVehicles && 
        <FeaturedVehicles 
          featuredVehicles={featuredVehicles} 
          numberFormatter={numberFormatter}
        />
      }
      <Testimonials/>
      <ContactInfo/>
    </>
  )
}

export default Home